export default __webpack_public_path__ + "static/media/mini_andar_bahar.ba04ab46.svg";